"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ALLOWABLE_MARKET_MOVEMENT = exports.DEFAULT_SLIPPAGE = exports.APPROVAL_GAS_LIMIT = void 0;
exports.APPROVAL_GAS_LIMIT = '100000'; // Most approvals are around 40k, we've seen 72k in the wild, so 100000 for safety.
exports.DEFAULT_SLIPPAGE = '0.03'; // 3%
exports.ALLOWABLE_MARKET_MOVEMENT = '0.01'; // 1%
